import { Component, OnInit } from '@angular/core';
import { User } from 'oidc-client';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private redirectUrl: string = "recover-tool";  
  private data: User;

  constructor(private authService: AuthenticationService, private router: Router) {}

  ngOnInit(): void {
    this.authService.completeAuthentication().then(() => {
      this.data = this.authService.getUser();
      this.router.navigate([this.redirectUrl]);
    });
  }
}
